import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { isTokenExpired } from "helpers/authSession";
import useLocalStorage from "helpers/useLocalStorage";

const WHATSAPP_SUPPORT_PHONE = "8562078344428";
const WHATSAPP_SUPPORT_MESSAGE = "ສະບາຍດີ! ຂ້ອຍຕ້ອງການຄວາມຊ່ວຍເຫຼືອກ່ຽວກັບແອັບ";

const hiddenPathPrefixes = [
  "/widgets",
  "/donate/obs/widget",
  "/donate/obs/goal",
];

export default function SupportFloatingButton() {
  const location = useLocation();
  const [token] = useLocalStorage("token", "");
  const hasActiveSession = Boolean(token && !isTokenExpired(token));
  const shouldHide =
    hasActiveSession ||
    hiddenPathPrefixes.some((pathPrefix) =>
      location.pathname.startsWith(pathPrefix),
    );

  if (shouldHide) {
    return null;
  }

  const supportUrl = `https://wa.me/${WHATSAPP_SUPPORT_PHONE}?text=${encodeURIComponent(
    WHATSAPP_SUPPORT_MESSAGE,
  )}`;

  return (
    <a
      className="support-floating-button"
      href={supportUrl}
      target="_blank"
      rel="noreferrer"
      aria-label="Contact support on WhatsApp"
      title="WhatsApp Support"
    >
      <FaWhatsapp aria-hidden="true" />
      <span>ຕິດຕໍ່ສອບຖາມ</span>
    </a>
  );
}
